import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const OfficerProfilePage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h4">Officer Profile</Typography>
          <Typography>Officer profile page - Coming soon</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OfficerProfilePage;